import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card_text, null, {
      default: _withCtx(() => [
        _createVNode(_component_quill_editor, {
          theme: "snow",
          "content-type": "html",
          toolbar: "full",
          content: _ctx.editorContent,
          "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editorContent) = $event))
        }, null, 8, ["content"])
      ]),
      _: 1
    })
  ]))
}